// extracted by mini-css-extract-plugin
export var chevronIcon = "_bi-2";
export var teamName = "_bi-1";
export var teamSwitcherButton = "_bi-0";